module.exports = __webpack_public_path__ + "saira-regular-webfont.a0578f83bfaf859675e6.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-regular-webfont.woff2
// module id = ../../../../../src/assets/fonts/saira-regular-webfont.woff2
// module chunks = styles